import { lazy } from 'react';
import loginProvider from './hoc/loginProvider';
import DomainModuleFactory from '@core/domain/index.module';
import FormManager from '@app/components/EasyForm';
import { Suspense } from '@app/components/Suspense';

const defaultState = { captchaToken: '', fiscalId: '', password: '' };
const formManager = new FormManager({ formIndex: 'login-form', defaultState });
const loginUseCase = DomainModuleFactory.user().createLoginUserCase();

const Lazy = lazy(() => import('./Page'));
const Page = props => <Suspense loaderMessage="LoadingPage" component={<Lazy {...props} />} />;

export default loginProvider({ formManager, loginUseCase, Page });
